import styled from 'styled-components';

const StyledLabel = styled.label``;

export { StyledLabel };
